import ProductCardProfile from "../../../../components/ProductCardProfile";

// Пріоритет і сети: діють певну кількість днів, їх не забирають у грі вручну
const ActivatedServices = ({ purchasesServices, onRefresh }) => {
    if (!purchasesServices.length) return null;

    return (
        <section className="bk-section">
            <h4 className="bk-section-title">Активні послуги <span className="bk-count">{purchasesServices.length}</span></h4>
            <div className="bk-grid">
                { purchasesServices.map((product) =>
                    <ProductCardProfile key={product._id} data={product} onRemove={onRefresh} />
                )}
            </div>
        </section>
    );
};

export default ActivatedServices;
